import { fetcher } from "helpers/fetcher";

import { TCompleteEodReportReq, TCompleteEodReportRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const completeEodReport = async (payload: TCompleteEodReportReq) => {
  return fetcher<TCompleteEodReportRes, TCompleteEodReportReq["data"]>(
    ENDPOINT.MANAGEMENT.COMPLETE_EOD_REPORT,
    {
      data: payload.data,
      headers: {
        [API_HEADER.BU_ID]: payload.idBu,
      },
      urlData: { date: payload.date },
    }
  );
};

export const mutationCompleteEodReport = async (
  payload: TCompleteEodReportReq
) => {
  return (await completeEodReport(payload)).data;
};

mutationCompleteEodReport._key = (payload: TCompleteEodReportReq) => [
  ENDPOINT.MANAGEMENT.COMPLETE_EOD_REPORT.url,
  payload,
];
